import React, { useState, useEffect } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import GameCard from "./GameCard";

export default function GameTabs({ tabsData, userId }) {
  const [activeTab, setActiveTab] = useState(0); // Keeps track of the active tab
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("Active"); // Default to "Active"

  const [cardsData, setCardsData] = useState(tabsData); // Manage all cards centrally
  const statusOptions = ["Active", "Inactive"];

  // Filter cards based on the selected status
  const filteredCards = cardsData[activeTab]?.cards?.filter((card) =>
    selectedStatus === "Active" ? card.isActive : !card.isActive
  );

  // Handle status toggle
  const handleToggleStatus = (cardId, newStatus) => {
    const updatedData = cardsData.map((tab) => ({
      ...tab,
      cards: tab.cards.map((card) =>
        card.id === cardId ? { ...card, isActive: newStatus } : card
      ),
    }));
    setCardsData(updatedData);
  };

  useEffect(() => {
    setCardsData(tabsData);
  }, [tabsData]);

  return (
    <div className=" pt-3">
      {/* Tabs Navigation */}
      <div className="flex justify-between">
        <div className="flex space-x-1 text-xs   ">
          {cardsData.map((tab, index) => (
            <button
              key={index}
              className={`flex space-x-1.5 text-xs max-xs:text-[10px] ${
                activeTab === index
                  ? "bg-[#65758B] p-2.5 max-xs:px-2 rounded-md text-white"
                  : "bg-[#E1E7EF] p-2.5 max-xs:px-2 rounded-md text-[#65758B]"
              }`}
              onClick={() => setActiveTab(index)} // Update active tab index
            >
              {tab.title}
            </button>
          ))}
        </div>

        {/* Status Dropdown */}
        <div>
          <div className="relative w-full">
            <button
              id="dropdownButton"
              className="w-full p-2 text-xs font-normal text-gray-700 bg-white border rounded-md shadow-sm flex justify-between items-center"
              onClick={() => setDropdownOpen(!dropdownOpen)}
            >
              <span>{selectedStatus}</span>
              <span className="text-gray-500 ms-1">
                {dropdownOpen ? (
                  <ChevronUp className="h-4 w-4" />
                ) : (
                  <ChevronDown className="h-4 w-4" />
                )}
              </span>
            </button>
            {dropdownOpen && (
              <ul className="absolute left-0 z-10 w-full mt-1 bg-white border rounded-md shadow-md">
                {statusOptions.map((status, index) => (
                  <li
                    key={index}
                    onClick={() => {
                      setSelectedStatus(status);
                      setDropdownOpen(false);
                    }}
                    className={`p-2 text-xs text-black hover:bg-[#E1E7EF] cursor-pointer flex justify-between items-center ${
                      index !== 0 ? "border-t border-[#E1E7EF]" : ""
                    }`}
                  >
                    {status}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </div>

      {/* Tab Content with Filter */}
      <div
        className="space-y-3 h-[774px] overflow-y-auto hide-scrollbar"
        style={{ height: "calc(100vh - 150px)" }}
      >
        {filteredCards?.length > 0 ? (
          filteredCards?.map((card, idx) => (
            <GameCard
              key={idx}
              {...card}
              userId={userId}
              onToggleStatus={handleToggleStatus}
            />
          ))
        ) : (
          <p className="text-gray-500 text-sm text-center mt-3">
            No users found for the selected filter.
          </p>
        )}
      </div>
    </div>
  );
}
